// import { mapGetters } from 'vuex'
import Helper from "@/Helper";
import VueCkeditor from "vue-ckeditor5";
import CKEDITOR from 'glviews-ckeditor5'
export default {
  name: "edit-comment",
  components: { 'vue-ckeditor-edit': VueCkeditor.component },
  props: [],
  data() {
    return {
      editor: CKEDITOR.ClassicEditor,
      editorConfig: {
        toolbar: {
          removeItems:['bold','italic','link','undo','redo'],
          items: []
        }
      },
      open_upload_file: false,
      comment: {},
      update_cmt: "",
      files: [],
      preview: [],
      errors: {},
      images_length: 0,
      index_img: [],
      cmt: {
        content: ""
      },
      attachfile: [],
      open_upload_image: false,
      checklist_item: {},
      image_index: [],
      btn_submit: false
    };
  },
  computed: {
    // ...mapGetters({
    //   profile: 'Profile/getProfile'
    // })
  },
  mounted() {},
  methods: {
    showModel(checklistitem = {}, comment) {
      this.$loading.start();
      this.$store
        .dispatch("Comment/showCommentOfChecklistItem", {
          checklist: { id: this.$route.params.checklist_id },
          checklist_item: checklistitem,
          comment
        })
        .then(res => {
          this.cmt = res;
          this.images_length = this.cmt.images.length;
          for (var i = 0; i < this.cmt.images.length; i++) {
            this.index_img.push(i);
          }
          this.preview = res.images_resize == "" ? [] : res.images_resize;
          this.files = [];
          this.checklist_item = checklistitem;
          this.image_index = [];
          this.$refs.modal_edit.show();
          this.$loading.complete();
        })
        .catch(errors => {
          console.log(errors);
          this.$loading.fail();
        });
    },
    update() {
      let attach =this.attachfile.length>0?this.attachfile: '';
      const data = new FormData();
      data.append("id", this.cmt.id);
      data.append("content", this.cmt.content.replace("\n", "<br/>")+attach);
      data.append("parent_id", this.cmt.parent_id);
      data.append("_method", "put");
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        data.append("images[" + i + "]", file);
      }
      for (var j = 0; j < this.image_index.length; j++) {
        let index = this.image_index[j];
        data.append("image_index[" + j + "]", index);
      }
      this.$loading.start();
      this.btn_submit = true;
      this.$store
        .dispatch("Comment/updateCommentOfChecklistItem", {
          checklist: { id: this.$route.params.checklist_id },
          checklist_item: this.checklist_item,
          comment: data
        })
        .then(res => {
          this.$notify({
            group: "success",
            title: this.$t("notify.notify"),
            text: this.$t("notify.update_success")
          });
          this.$refs.modal_edit.hide();
          this.cmt = {};
          this.files = [];
          this.preview = [];
          this.image_index = [];
          this.attachfile = []
          this.errors = {};
          this.$loading.complete();
          this.$emit("updateSuccess", res);
          this.btn_submit = false;
        })
        .catch(errors => {
          if (errors.status === 422) {
            this.errors = errors.data.error;
          }
          this.btn_submit = false;
          this.$loading.fail();
        });
    },
    openUploadImage() {
      this.open_upload_image = !this.open_upload_image;
      this.open_upload_file = false;
    },
    change(event) {
      this.open_upload_image = false;
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i]);
        let reader = new FileReader();
        reader.onload = event => {
          // console.log(event)
          this.preview.push(event.target.result);
        };
        reader.readAsDataURL(this.$refs.files.files[i]);
      }
    },
    remove(index) {
      index >= this.images_length
        ? this.files.splice(index - this.images_length, 1)
        : "";

      if (index < this.images_length) {
        this.images_length = this.images_length - 1;
        this.image_index.push(this.index_img[index]);
        this.index_img.splice(index, 1);
      }

      this.preview.splice(index, 1);
      delete this.errors["images." + index];
    },

    // Attrack file
    openUploadFile() {
      this.open_upload_file = !this.open_upload_file;
      this.open_upload_image = false;
    },
    //event upload file
    uploadFileInUpdate(event) {
      console.log(this.$refs.files.files[0], this.attachfile);
      const fd = new FormData();
      fd.append("file", this.$refs.files.files[0]);
      fd.append("type", "file");
      this.$store
        .dispatch("Comment/attachFileInComment", { file: fd })
        .then(res => {
          console.log(res);
          this.attachfile.push('<a target="_blank" href=https://docs.google.com/viewerng/viewer?url=' +res +">" +this.$refs.files.files[0].name +"</a>");
          console.log(this.attachfile);
          this.open_upload_file = !this.open_upload_file;
        })
        .catch(errors => {
          if (errors.status === 422) {
            this.errors = errors.data.error;
            this.open_upload_file = !this.open_upload_file;
          }
          this.$loading.fail();
        });
    },

    //remove file attach
    removeFile(index) {
      this.attachfile.splice(index, 1);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/checklist/view/checklist-item/comment/edit-comment/edit-comment.js